var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextField, MenuItem } from '@mui/material';
var SelectField = function (_a) {
    var error = _a.error, errorMessage = _a.errorMessage, items = _a.items, onChange = _a.onChange, variant = _a.variant, value = _a.value, multiple = _a.multiple, otherProps = __rest(_a, ["error", "errorMessage", "items", "onChange", "variant", "value", "multiple"]);
    var handleChange = React.useCallback(function (ev) {
        onChange(ev.target.value);
    }, [onChange]);
    return (React.createElement(TextField, __assign({ select: true, SelectProps: {
            multiple: multiple,
        }, error: error || Boolean(errorMessage), value: value, onChange: handleChange, variant: variant || 'outlined' }, otherProps), items.map(function (_a) {
        var text = _a.text, value = _a.value;
        return (React.createElement(MenuItem, { key: value, value: value }, text));
    })));
};
export default SelectField;
